export const GETCONFIG_REQUEST_BOT_RESET = 'GETCONFIG_REQUEST_BOT_RESET'
export const GETCONFIG_REQUEST_BOT = 'GETCONFIG_REQUEST_BOT'
export const GETCONFIG_SUCCESS_BOT = 'GETCONFIG_SUCCESS_BOT'
export const GETCONFIG_FAILURE_BOT = 'GETCONFIG_FAILURE_BOT'
export const GET_LANG_SUCCESS = 'GET_LANG_SUCCESS'
